import React from 'react';
import ReactDOM from 'react-dom';
import RelatedTermsItem from './related-terms-item.jsx';
import { populate } from './../utils/populate.js';

class RelatedTerms extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      baseQuery: "/rest/committees/",
      query: "",
      data: [],
      mapData: []
    };

    this.populateAll = this.populateAll.bind(this);

  }

  componentDidMount() {
    let relatedTerm = document.getElementById("react--related--terms").dataset.term;
    this.setState({
      query: relatedTerm + '?_format=json'
    }, () =>
      this.populateAll()
    )
  }

  populateAll() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}${query}`).then(function( response ){
      that.setState({
        data: response
      })
    });
  }

  render() {
    const { data} = this.state;

      return(
        <div>
          {
            data.map((item, index) => {
              return(
                <RelatedTermsItem item={item} key={index} />
              );
            })
          }
        </div>
      )
  }
}

if ( document.getElementById('react--related--terms') ) {
  ReactDOM.render(
    <RelatedTerms/>,
    document.getElementById('react--related--terms')
  );

}









